export default __webpack_public_path__ + "static/media/tiktok.07cf919f.svg";